/**
 * 隐私政策页（`/privacy` · N 域 N5）
 *
 * 🔴 与协议页同一条纪律：**未登录可读**（注册前必须能看到"我们收集什么"）。
 * 🔴 第 6 节写的是「**当前版本没有启用任何 AI 分析**」—— 这是**事实**（`modules/` 里没有 `ai`），
 *    不是"我们以后会保护你"的空话。AI 域上线时必须同批改这一节，否则就是虚假陈述。
 */

import type { ReactElement } from 'react';
import { LegalDoc } from '../ui/LegalDoc.js';
import { PRIVACY_SECTIONS, PRIVACY_TITLE, TERMS_TITLE } from '../features/legal-content.js';

export function PrivacyPage(): ReactElement {
  return (
    <LegalDoc
      title={PRIVACY_TITLE}
      sections={PRIVACY_SECTIONS}
      sibling={{ label: TERMS_TITLE, to: '/terms' }}
      testId="privacy-page"
    />
  );
}
